<template>
  <!-- 岗位安全风险告知卡 -->
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <label type="button" class="btn btn-success" style="padding: 7px 12px;font-size: 12px;">
          <input type="file" @change="fileUpload($event)" accept="image/*" />
          上传图片
        </label>
        <label
          v-if="imgList.length > 0"
          type="button"
          style="margin-left:10px;padding: 7px 12px;font-size: 12px"
          class="btn btn-success"
          @click="deleteClick"
        >
          删除图片
        </label>
        <el-button size="small" type="primary" style="margin-left:10px" @click="sel">指南</el-button>
      </div>
    </div>
    <div class="page_table_box">
      <div
        class="school_table_box"
        style="display: flex;justify-content: center;align-items: center;"
      >
        <el-image
          v-for="(item, index) in imgList"
          :key="index"
          fit="scale-down"
          style="height:100%"
          :src="$store.state.config.fileUrl + item.url"
          :preview-src-list="[$store.state.config.fileUrl + item.url]"
        >
        </el-image>
      </div>
      <div class="pagination_box" v-if="dataList.total > 0">
        <el-pagination
          @current-change="riskImagesPage"
          :current-page="searchData.pageNum"
          :page-size="searchData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="dataList.total"
        >
        </el-pagination>
      </div>
    </div>
    <introduce-dialog :dialogResize="dialogResize"></introduce-dialog>
  </div>
</template>

<script>
import introduceDialog from "./components/RiskNoticeDialog.vue"
export default {
  name: "",
  components: {
    introduceDialog
  },
  props: {},
  data() {
    return {
      fileInfo: {
        id: "",
        url: ""
      },
      imgList: [],
      // 文件上传临时存储
      oneFileUploadData: "",
      // 数据列表
      dataList: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
        pages: 0,
        dataInfo: []
      },

      // 请求数据
      searchData: {
        schoolId: this.$store.state.schoolId,
        pageNum: 1, // 第几页
        pageSize: 1 // 多少条
      },
      dialogResize: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    sel() {
      this.dialogResize++;
    },
    // 风险告知卡翻页
    riskImagesPage(val) {
      this.searchData.pageNum = val;
      this.getRiskNotificationCard();
      console.log(`当前页: ${val}`);
    },
    // 文件上传1
    async fileUpload(event) {
      var fileUpload = event.target.files[0];
      if (!fileUpload) {
        return;
      }
      var requestData = {
        file: fileUpload
      };
      const loading = this.$loading({
        lock: true,
        text: "文件上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let saveData = await this.$Http.oneFileUpload(requestData, true);
      // console.log(saveData)
      var newFileInfo = {};
      for (var testData in saveData.data) {
        newFileInfo = {
          fileName: testData,
          fileUrl: saveData.data[testData]
        };
      }
      this.oneFileUploadData = newFileInfo;

      loading.close();
      this.addNotificationCard();
    },

    // 添加风险告知卡
    async addNotificationCard() {
      var requestParams = {
        schoolId: this.$store.state.schoolId,
        url: this.oneFileUploadData.fileUrl
      };
      let saveData = await this.$Http.addNotificationCard(requestParams, true);
      if (saveData.code == 200) {
        this.$message({
          type: "success",
          message: "文件上传成功"
        });
        this.getRiskNotificationCard();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: saveData.messsage
        });
      }
    },

    // 获取岗位安全风险告知卡
    async getRiskNotificationCard() {
      var newParamData = {
        schoolId: this.searchData.schoolId,
        pageNum: this.searchData.pageNum,
        pageSize: this.searchData.pageSize
      };
      let res = await this.$Http.getRiskNotificationCard(this.searchData);
      // console.log(res);
      if (res.code == 200) {
        this.dataList.pageSize = res.data.pageSize;
        this.dataList.pageNum = res.data.pageNum;
        this.dataList.total = res.data.total;
        this.dataList.pages = res.data.pages;
        this.imgList = res.data.list || [];
        if (res.data.list.length > 0) {
          this.fileInfo.url = res.data.list[0].url;
          this.fileInfo.id = res.data.list[0].id;
        }
        
        // console.log(this.dataList);
      } else if (res.code == 101) {
        this.imgList = [];
        this.dataList.pageSize = 1;
        this.dataList.pageNum = 1;
        this.dataList.total = 0;
        this.dataList.pages = 0;
      } else {
        this.imgList = [];
        this.dataList.pageSize = 1;
        this.dataList.pageNum = 1;
        this.dataList.total = 0;
        this.dataList.pages = 0;
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    deleteClick() {
      this.$confirm("此操作将永久删除该图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.riskAnnouncementDelete();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    async riskAnnouncementDelete() {
      let res = await this.$Http.deleteRiskNoticePicture(
        { id: this.fileInfo.id },
        true
      );
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.getRiskNotificationCard();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "删除失败"
        });
      }
    }
  },
  created() {},
  mounted() {
    this.getRiskNotificationCard();
  }
};
</script>
<style scoped></style>
